import { Component } from "@angular/core";
import { ActionButtonsComponent } from "../action-buttons/action-buttons.component";

/**
 * Same behaviour as {@link ActionButtonsComponent} but without the fallback
 * text span. When every command is hidden the cell renders nothing (a void
 * cell) instead of printing the raw column value.
 *
 * Used by the recovery-plan column so that ineligible rows (rpStatus "" or
 * "Deleted" with no create button) show an empty cell rather than "0".
 */
@Component({
  selector: "app-action-buttons-no-text",
  templateUrl: "./action-buttons-no-text.component.html",
  styleUrls: ["../action-buttons/action-buttons.component.scss"],
})
export class ActionButtonsNoTextComponent<T extends object> extends ActionButtonsComponent<T> {}
